import FormCheckbox from './FormCheckbox'

export default FormCheckbox
